/**
 * Created by admin on 2018/5/30.
 */
import React, { PureComponent } from 'react';
import { connect } from 'dva';
import { Input, Modal, TreeSelect, Spin } from 'antd';
import { FormattedMessage, injectIntl } from 'react-intl';
import './UserAddEdit.less';
import { Btn, RequiredSign } from '../../../components/Widgets';
import {CHINESE, USER_FROM} from '../../../utils/constants';

const TreeNode = TreeSelect.TreeNode;

class UserAddEdit extends PureComponent {
  static defaultProps = {
    visible: false,
    addEditUser: {}
  };

  constructor() {
    super();
    this.state = {
      userId: '',
      name: '',
      company: '',
      dept: '',
      deptId: 0,
      deptNodeCode: '',
      mobile: '',
      email: '',
      cardNo: '',
      staffID: ''
    };
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.visible && nextProps.visible && nextProps.addEditUser) {
      const { addEditUser } = nextProps;
      this.setState({
        userId: addEditUser.userId,
        name:
          (addEditUser.firstName ? addEditUser.firstName : '') +
          (addEditUser.givenName ? addEditUser.givenName : ''),
        company: addEditUser.company,
        dept: addEditUser.dept,
        deptNodeCode: addEditUser.deptNodeCode,
        mobile: addEditUser.mobile,
        email: addEditUser.email,
        cardNo: addEditUser.cardNo,
        staffID: addEditUser.staffID
      });
    }
  }

  render() {
    const {
      visible,
      addEditUser,
      userAddEditStatus,
      allDept,
      intl,
      loading
    } = this.props;
    const {
      name,
      mobile,
      email,
      staffID,
      deptNodeCode,
      userId,
      cardNo = ''
    } = this.state;
    const fromSyn = addEditUser.userFrom !== USER_FROM.local && !!addEditUser.id;

    let title = intl.formatMessage({ id: 'meeting_dept_user_add' });
    if (userAddEditStatus == 2) {
      title = intl.formatMessage({ id: 'meeting_dept_user_edit' });
    }
    const getTreeNode = depts =>
      depts.map(dept => {
        if (dept.depts && dept.depts.length) {
          return (
            <TreeNode
              key={dept.nodeCode}
              value={dept.nodeCode}
              title={dept.name}
            >
              {getTreeNode(dept.depts)}
            </TreeNode>
          );
        }
        return (
          <TreeNode
            key={dept.nodeCode}
            value={dept.nodeCode}
            title={dept.name}
          />
        );
      });

    let  leftClass = intl.locale === CHINESE?'prefix-title':'prefix-title-en';
    return (
      <Modal
        visible={visible}
        title={title}
        onCancel={this.closeHandle}
        wrapClassName="modal-close-header user-addEdit-modal-header"
        footer={
          <div className="user-addEdit-footer">
            <Btn onClick={this.closeHandle}>
              <FormattedMessage id="dialog_btn_cancel"/>
            </Btn>
            <Btn primary onClick={this.addEditUser}>
              <FormattedMessage id="dialog_btn_ok"/>
            </Btn>
          </div>
        }
        width={800}
      >
        <Spin spinning={loading} size="large">
          <div className="user-addEdit-content">
            <div className="user-addEdit-row">
            <span className={leftClass}>
              <RequiredSign/>
              <FormattedMessage id="user_id"/> :{' '}
            </span>
              <Input
                disabled={!!addEditUser.id}
                value={userId}
                onChange={this.onChange.bind(this, 'userId')}
              />
            </div>
            <div className="user-addEdit-row">
            <span className={leftClass}>
              <RequiredSign/>
              <FormattedMessage id="index_username"/> :{' '}
            </span>
              <Input maxLength="36" disabled={fromSyn} value={name} onChange={this.onChange.bind(this, 'name')}/>
            </div>
            <div className="user-addEdit-row">
            <span className={leftClass}>
              <RequiredSign/>
              <FormattedMessage id="user_department"/> :{' '}
            </span>
              <TreeSelect
                style={{ width: '100%' }}
                value={deptNodeCode}
                disabled={fromSyn}
                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                placeholder={intl.formatMessage({ id: 'pls_check_depart' })}
                allowClear
                treeDefaultExpandAll
                onChange={this.onDeptTreeChange}
              >
                {getTreeNode(allDept)}
              </TreeSelect>
            </div>
            <div className="user-addEdit-row">
            <span className={leftClass}>
              <FormattedMessage id="user_edit_cardNo"/> :{' '}
            </span>
              <Input
                value={cardNo}
                maxLength={'50'}
                onChange={this.onChange.bind(this, 'cardNo')}
              />
            </div>

            <div className="user-addEdit-row">
            <span className={leftClass}>
              <FormattedMessage id="index_phone"/> :{' '}
            </span>
              <Input
                value={mobile}
                disabled={fromSyn}
                onChange={this.onChange.bind(this, 'mobile')}
              />
            </div>
            <div className="user-addEdit-row">
            <span className={leftClass}>
              <FormattedMessage id="index_email"/> :{' '}
            </span>
              <Input value={email} disabled={fromSyn} onChange={this.onChange.bind(this, 'email')}/>
            </div>
            {addEditUser.staffID &&
            <div className="user-addEdit-row">
              <span className={leftClass}>
                <FormattedMessage id="index_staffID" /> : {' '}
              </span>
              <Input value={staffID} disabled={!!addEditUser.staffID} onChange={this.onChange.bind(this, 'staffID')}/>
            </div>
            }
          </div>
        </Spin>
      </Modal>
    );
  }

  onDeptTreeChange = (value, label) => {
    this.setState({
      deptNodeCode: value,
      dept: label && label.length > 0 ? label[0] : ''
    });
  };
  onChange = (property, e) => {
    this.setState({ [property]: e.target.value });
  };

  addEditUser = () => {
    const { dispatch, addEditUser, loading, intl } = this.props;
    if (loading) return;
    const {
      userId,
      name,
      company,
      dept,
      mobile,
      email,
      deptId,
      deptNodeCode,
      cardNo
    } = this.state;
    if (!userId) {

      Modal.error({ content: intl.formatMessage({id: 'user_check_user_id_info'})});
      return;
    }
    if (!name) {
      Modal.error({ content: intl.formatMessage({id: 'user_check_user_name_info'})});
      return;
    }
    if (!deptNodeCode) {
      Modal.error({ content: intl.formatMessage({id: 'user_check_user_name_dep'})});
      return;
    }
    const user = {
      ...addEditUser,
      ...{
        firstName: name,
        givenName: '',
        company,
        dept,
        deptId,
        deptNodeCode,
        mobile,
        userId: addEditUser.userId ? addEditUser.userId : userId,
        email,
        cardNo
      }
    };
    dispatch({ type: 'deptUserManage/userSaveOrUpdate', user });
  };

  closeHandle = () => {
    const { onCancel } = this.props;
    onCancel && onCancel();
  };
}

const mapStateToProps = state => {
  return {
    loading: state.loading.models['deptUserManage']
  };
};

export default connect(mapStateToProps)(injectIntl(UserAddEdit));



// WEBPACK FOOTER //
// ./src/routes/SystemConfig/DeptUserManage/UserAddEdit.js